import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';

import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

import Dialog, {
  DialogActions,
  DialogContent,
} from 'components/common/Dialog';
import Button from 'components/common/Button';

import { deletePatient } from 'redux/modules/patients';
import { removeRouterParamsTabs } from 'redux/modules/routerParams';

const styles = () => ({
  message: {
    padding: '60px 85px',
  },
  subheading: {
    marginBottom: 17,
  },
});

const PatientDeleteDialog = ({ open, onClose, actions, history, classes, ...otherProps }) => (
  <Dialog
    open={open}
    onClose={onClose}
    maxWidth="sm"
  >
    <DialogContent>
      <div className={classes.message}>
        <Typography
          className={classes.subheading}
          variant="subheading"
        >
          Are you sure that you want to delete this chart for patient
          {` ${otherProps['Last Name']}`}
          {`, ${otherProps['First Name']}`}
          {otherProps['Middle Name'] && ` ${otherProps['Middle Name']}`}
          ?
        </Typography>
        <Typography color="secondary">
          Сaution: this can not be undone
        </Typography>
      </div>
    </DialogContent>
    <DialogActions>
      <Button
        onClick={onClose}
        variant="raised"
      >
        Cancel
      </Button>
      <Button
        onClick={() => {
          actions.deletePatient({ 'Record Number': otherProps['Record Number'] });
          actions.removeRouterParamsTabs({
            patient: [otherProps['Record Number']],
          });
          history.replace('/charts');
        }}
        variant="raised"
        color="warning"
      >
        DELETE
      </Button>
    </DialogActions>
  </Dialog>
);

PatientDeleteDialog.propTypes = {
  open: PropTypes.bool,
  'Record Number': PropTypes.number.isRequired,
  'First Name': PropTypes.string.isRequired,
  'Middle Name': PropTypes.string,
  'Last Name': PropTypes.string.isRequired,
  onClose: PropTypes.func,
  actions: PropTypes.shape({
    deletePatient: PropTypes.func.isRequired,
    removeRouterParamsTabs: PropTypes.func.isRequired,
  }).isRequired,
  history: PropTypes.shape({
    replace: PropTypes.func.isRequired,
  }).isRequired,
  classes: PropTypes.shape({
    message: PropTypes.string.isRequired,
    subheading: PropTypes.string.isRequired,
  }).isRequired,
};

PatientDeleteDialog.defaultProps = {
  open: false,
  onClose: () => {},
  'Middle Name': '',
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ deletePatient, removeRouterParamsTabs }, dispatch),
});

export default withRouter(
  connect(null, mapDispatchToProps)(withStyles(styles)(PatientDeleteDialog)),
);



// WEBPACK FOOTER //
// ./src/components/patient/PatientDeleteDialog/PatientDeleteDialog.js